import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

/**
 * FAQSchema Component
 * Renders FAQ items as an accordion AND outputs JSON-LD schema for Google.
 *
 * @param {Array} faqs - Array of { question, answer } objects
 */
export const FAQSchema = ({ faqs = [] }) => {
  const [openIndex, setOpenIndex] = useState(null);

  if (!faqs || faqs.length === 0) return null;

  const toggle = (idx) => setOpenIndex(openIndex === idx ? null : idx);

  // JSON-LD structured data
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      {/* JSON-LD for Google */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      {/* Visual FAQ Accordion */}
      <section className="faq-section" data-testid="faq-section">
        <h2 className="text-2xl font-playfair font-bold text-gray-900 mb-6 pb-3 border-b-2 border-gray-200">
          Frequently Asked Questions
        </h2>
        <div className="space-y-0">
          {faqs.map((faq, idx) => (
            <div key={idx} className="faq-item" data-testid={`faq-item-${idx}`}>
              <button
                className="faq-question"
                onClick={() => toggle(idx)}
                aria-expanded={openIndex === idx}
                data-testid={`faq-toggle-${idx}`}
              >
                <span>{faq.question}</span>
                {openIndex === idx ? (
                  <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" />
                )}
              </button>
              {openIndex === idx && (
                <div className="faq-answer" data-testid={`faq-answer-${idx}`}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default FAQSchema;
